import {
  SIGNIN_USER_REQUESTED,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_FAILURE,
  SIGNOUT_USER,
  ME_FROM_TOKEN_REQUESTED,
  ME_FROM_TOKEN_SUCCESS,
  ME_FROM_TOKEN_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  AUTHENTICATE_WITH_TOKEN_REQUESTED,
  AUTHENTICATE_WITH_TOKEN_SUCCESS,
  AUTHENTICATE_WITH_TOKEN_FAILURE,
} from '../actions/users';

const INITIAL_STATE = {currentUser: null, status: null, error: null, loading: false};

let usersReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case SIGNIN_USER_REQUESTED:
      return {
        ...state,
        currentUser: null,
        status: 'signin',
        error: null,
        loading: true
      };
    case SIGNIN_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.user,
        token: action.token,
        status: 'authenticated',
        error: null,
        loading: false
      };
    case SIGNIN_USER_FAILURE:
      let error = action.error.user_authentication;
      return {
        ...state,
        currentUser: null,
        token: null,
        status: 'signin',
        error: error,
        loading: false
      };
    case SIGNOUT_USER:
      return {
        ...state,
        currentUser: null,
        token: null,
        status: 'signout',
        error: null,
        loading: false
      };
    case ME_FROM_TOKEN_REQUESTED:
      return {
        ...state,
        status: 'storage',
        loading: true
      };
    case ME_FROM_TOKEN_SUCCESS:
      return {
        ...state,
        currentUser: action.user,
        status: 'authenticated',
        error: null,
        loading: false
      };
    case ME_FROM_TOKEN_FAILURE:
      return {
        ...state,
        currentUser: null,
        token: null,
        status: 'storage',
        error: action.error,
        loading: false
      };
    case UPDATE_USER:
      return {
        ...state,
        currentUser: null,
        token: null,
        status: 'storage',
        error: null,
        loading: true
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.updatedUser,
        token: action.token,
        status: 'authenticated',
        error: null,
        loading: false
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case AUTHENTICATE_WITH_TOKEN_REQUESTED:
      return {
        ...state,
        currentUser: null,
        status: 'signin',
        error: null,
        loading: true
      };
    case AUTHENTICATE_WITH_TOKEN_SUCCESS:
      return {
        ...state,
        currentUser: action.user,
        token: action.token,
        status: 'authenticated',
        error: null,
        loading: false
      };
    case AUTHENTICATE_WITH_TOKEN_FAILURE:
      error = action.error.user_authentication;
      return {
        ...state,
        currentUser: null,
        token: null,
        status: 'signin',
        error: error,
        loading: false
      };
    default:
      return state;
  }
}

export default usersReducer
